import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { AttestationChallenge } from '~/components/attestation-challenge/attestation-challenge';
import { useAttestationChallenge } from '~/components/attestation-challenge/use-attestation-challenge';
import { m } from '~/paraglide/messages.js';
import { setLocalStorageItem } from '~/utils/local-storage';
import { AccountProfileComponent } from './-components/account-profile';

export const Route = createFileRoute('/auth/signup/')({
  validateSearch: (
    search: Record<string, string>,
  ): { redirect?: string; email?: string; phone?: string } => {
    return {
      redirect: search.redirect,
      email: search.email,
      phone: search.phone,
    };
  },
  component: SignupPage,
});

function SignupPage() {
  const { redirect, email, phone } = Route.useSearch();
  const { handleAttestationChallenge } = useAttestationChallenge({
    authFlow: 'signup',
  });

  useEffect(() => {
    if (redirect) {
      setLocalStorageItem('redirect', redirect);
    }
  }, []);

  return (
    <div className="w-full min-h-[80vh] flex flex-col justify-center items-center">
      <div className="text-center space-y-2 mb-6">
        <h1 className="text-2xl font-semibold text-gray-900 dark:text-white">
          {m['auth.signup.title']()}
        </h1>
        <p className="text-gray-600 dark:text-gray-300">
          {m['auth.signup.subtitle']()}
        </p>
      </div>

      <div className="w-full max-w-md space-y-6">
        <AttestationChallenge
          handleAttestationChallenge={handleAttestationChallenge}
        />
        <AccountProfileComponent initialEmail={email} initialPhone={phone} />
      </div>
    </div>
  );
}
